import React from 'react'
import PropTypes from 'prop-types'

class BackwashTooltip extends React.Component {
  render() {
    const { active } = this.props

    if (active) {
      const { payload, label } = this.props

      if (payload && payload[0]) {
        var createdAt = payload[0].payload.createdAt
        var employee = payload[0].payload.employee

        if (payload[0].value == 2) {
          var backwash = 'Yes'
        }
        else {
          var backwash = 'No'
        }

        return (
          <div className="well shadowDepth1">
            <p>
              <span className="grey-text">
                {createdAt}
                <br />
                {employee}
              </span>
              <br />
              <span className="small-text">
                <span style={{color: payload[0].color}}>
                  Backwash: {backwash}
                </span>
                <br />
              </span>
            </p>
          </div>
        );
      }
      else {
        return null
      }
    }

    return null
  }
}

BackwashTooltip.propTypes = {
  type: PropTypes.string,
  payload: PropTypes.array,
  label: PropTypes.string,
}

export default BackwashTooltip
